import { QueryState } from '@/common/enum';

export const AuthInitialState: AuthTypes = {
  queryState: QueryState.UNDEFINED,
  token: null,
  tokenVerification: null,
  accessType: null,
  userId: null,
  error: null,
};
